
export const SystemLogsGetListSchema = {
    logSeverity: 'logSeverity',
    logSeverityValues: {
        message: 'MESSAGE',
        warning: 'WARNING',
        error: 'ERROR'
    },
    date: 'date',
    hostName: 'hostName',
    serviceDomain: 'serviceDomainName',
    application: 'application',
    user: 'user',
    message: 'message',
    information: 'information',
    informationFields: 'informationFields'
}

export const SystemLogsSeverities = {
    debug: 7,
    info: 6,
    notice: 5,
    warn: 4,
    error: 3,
    critical: 2,
    alert: 1,
    emergency: 0
}

export const SystemLogsFilterSchema = {
    freeTextSearch: 'freeTextSearch',
    isGlobalScope: 'isGlobalScope',
    startDate: 'startDate',
    endDate: 'endDate',
    origin: 'origin',
    user: 'user',
    minSeverity: 'minSeverity',
    linesLimit: 'linesLimit'
}